import React, { useMemo, useState } from 'react';

import Axios from 'axios';

import { forceReloadEvent } from '@hooks/API/Event/UseEvent';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { NwButton } from '@components/Gui/NwButton';

const ModelsTableAddAllModelsButton = ({ models }) => {
    const { context } = useContactsSelector();
    const { currentEvent } = context;
    const cs_dispatch = useContactsSelectorDispatch();

    const [addingModelToAllDates, setAddingModelToAllDates] = useState(false);

    const isModelInEvent = (model) => {
        return currentEvent.EventDates.some((ed) =>
            ed.EventDatesModels.some((edm) => Number(edm.ModelID) === Number(model.ID))
        );
    };

    const handleUpdateEvent = async () => {
        const eventUpdated = await Axios.get(`/events/${currentEvent.ID}`);
        cs_dispatch({ type: 'UpdateCurrentEvent', eventUpdated: eventUpdated });
    };

    const modelsNotInEvent = useMemo(() => {
        return models.filter((model) => !isModelInEvent(model));
    }, [models]);

    const handleAllModelsAddAllDates = async () => {
        setAddingModelToAllDates(true);
        try {
            const eventDatesToSend = currentEvent.EventDates.map((ed) => ({
                ID: ed.ID,
                OptionNumber: null,
            }));
            const dataToSend = {
                ModelIDs: models.map((model) => model.ID), //modelsNotInEvent.map((model) => model.ID),
                EventDates: [...eventDatesToSend],
            };
            await Axios.post('/eventdatesmodels/AddModelsToDates', dataToSend);
            forceReloadEvent(currentEvent.ID);
            await handleUpdateEvent();
            setAddingModelToAllDates(false);
        } catch (error) {
            console.error('Add Models to EventDate Error => ', error);
            setAddingModelToAllDates(false);
        }
    };

    return (
        <NwButton
            primary
            disabled={models.length > 500}
            loading={addingModelToAllDates}
            label="add all models to all dates"
            onClick={handleAllModelsAddAllDates}
            tooltip={
                models.length > 500
                    ? "you can't add more than 500 models to a casting"
                    : 'all models will be added to all dates of the casting'
            }
        />
    );
};

export default ModelsTableAddAllModelsButton;
